/**
 * @fileoverview Modal component for rendering a modal with a backdrop and modal content
 *
 * @example
 * // Usage in component:
 * import { Modal } from './Modal'
 *
 * <Modal render={() => <div>Test</div>} onClose={() => {}} />
 */

import { ModalConfig } from '../../ModalContext'
import css from './Modal.module.css'

Modal.defaultProps = {
    confirmText: 'buttons.yes',
    cancelText: 'buttons.no',
    canClose: true,
}

/**
 * @function Modal
 * @description Component for rendering a modal with a backdrop and modal content
 * @param {ModalConfig} props - The props for the component
 * @returns {JSX.Element} The Modal component
 */
export function Modal(props: ModalConfig) {
    return (
        <div className={css.backdrop}>
            <div className={css.modal}>
                {props.canClose && (
                    <button
                        data-testid="close-modal"
                        className={css.closeIconContainer}
                        onClick={props.onClose}
                    >
                        <img
                            src="https://novoic-static.s3.us-west-2.amazonaws.com/close.svg"
                            alt="Close modal"
                        />
                    </button>
                )}
                {props.render(props)}
            </div>
        </div>
    )
}
